import { FC } from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Grid,
  Heading,
  Spinner,
  Text,
} from "@radix-ui/themes";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useTenantZoneChallenges } from "@/features/challenge/hooks/useTenantZoneChallenges";
import { ChallengeCard } from "@/features/challenge";
import { Zones } from "@/models/database/zones/Zones.model";
import { siteRoutes } from "@/routes/siteRoutesList";
import { useNavigate } from "react-router-dom";

interface SingleZoneChallengesProps {
  zone: Zones;
}

export const SingleZoneChallenges: FC<SingleZoneChallengesProps> = ({
  zone,
}): JSX.Element => {
  const navigate = useNavigate();
  const { data, loading, error } = useTenantZoneChallenges(
    brand.tenantId,
    zone.slug
  );

  const hasMoreThanTwo = data && data.length > 3;
  const UpToTwoChallenges = data && data.slice(0, 2);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <Text>Error: {error.message}</Text>;
  }

  return (
    <Container px={{ initial: "4", md: "2", xl: "0" }}>
      <Heading>Active Challenges</Heading>
      <Grid columns={{ initial: "1", lg: "3" }} gap="5">
        {data && data.length > 0 ? (
          UpToTwoChallenges.map((challenge) => {
            const key = challenge.slug;

            return (
              <Box key={key}>
                {/* Render challenge card */}
                <ChallengeCard
                  created={challenge.created}
                  createdBy={challenge.author?.uid} // Possibility of author profile get deleted
                  creatorType={challenge.creatorType}
                  fieldToCompare={
                    challenge.challengeAdditionalData.fieldToCompare
                  }
                  game={challenge.game}
                  gameType={challenge.gameType}
                  goal={"win"} // Not getting from backend
                  logoUrl={challenge.logoUrl}
                  name={challenge.name}
                  slug={challenge.slug}
                  author={challenge.author}
                  startDate={{
                    _seconds: challenge.startDate.seconds,
                    _nanoseconds: challenge.startDate.nanoseconds,
                  }}
                  endDate={{
                    _seconds: challenge.endDate.seconds,
                    _nanoseconds: challenge.endDate.nanoseconds,
                  }}
                  status={challenge.status}
                  zone={zone}
                />
              </Box>
            );
          })
        ) : (
          <Text>No challenges available</Text>
        )}
      </Grid>
      {hasMoreThanTwo && (
        <Flex justify="center">
          <Button
            onClick={() =>
              navigate(
                `${siteRoutes["zone"]}${zone.slug}${siteRoutes["challenges"]}`
              )
            }
          >
            View more challenges
          </Button>
        </Flex>
      )}
    </Container>
  );
};
